exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pi-ai-text[data-v-55b56a90]{white-space:pre-line}.pi-ai-text__code[data-v-55b56a90]{padding:0 3px;border-radius:3px;background:#f1f2f4;color:#1f2933;font-size:.95em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-55b56a90","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/components/pi/piAssistantText.vue
// module id = 1835
// module chunks = 0